import { useController } from 'react-hook-form';
import type { ColumnPinningState, OnChangeFn, Updater } from '@tanstack/react-table';
import { useCallback } from 'react';

export const useColumnPinningState = (): [ColumnPinningState, OnChangeFn<ColumnPinningState>] => {
  const { field } = useController({ name: 'columnPinning' });

  const onPinningChange: OnChangeFn<ColumnPinningState> = useCallback(
    (updaterOrValue: Updater<ColumnPinningState>) => {
      const nextState = typeof updaterOrValue === 'function' ? updaterOrValue(field.value) : updaterOrValue;

      field.onChange(nextState);
    },
    [field],
  );

  return [field.value, onPinningChange];
};
